var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 124,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73 64.46c-.41 0-.81-.15-1.12-.46l-2.9-2.9c-.62-.62-.62-1.62 0-2.24.62-.62 1.62-.62 2.24 0l2.9 2.9c.62.62.62 1.62 0 2.24-.31.3-.71.46-1.12.46Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.99 122.6a1.388 1.388 0 0 1-.98-2.37l2.55-2.55c.54-.54 1.42-.54 1.96 0s.54 1.42 0 1.96l-2.55 2.55c-.27.27-.62.41-.98.41Z",
    stroke: "#4263EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.59 123.97a2.62 2.62 0 1 0 0-5.24 2.62 2.62 0 0 0 0 5.24Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34 102.21a1.55 1.55 0 1 0 0-3.1 1.55 1.55 0 0 0 0 3.1Z",
    stroke: "#4263EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.85 5.25 17.55 12.4M12.81 81.53l22.65-6.18M57.73 108.59l13-10.4M2.61 47.21l39.36 6.15M.96 94.4c.49 7.4 6.87 13 14.28 12.52M64.68 1.41c-4.01 0-7.25 3.24-7.25 7.25",
    stroke: "#4263EB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.103 57.602c5.185-2.394 7.483-8.46 5.133-13.55-2.35-5.09-8.458-7.274-13.642-4.88-5.185 2.393-7.483 8.46-5.133 13.549 2.35 5.09 8.458 7.275 13.642 4.88Z",
    fill: "#3B5BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.164 56.179c5.185-2.394 7.483-8.46 5.133-13.55-2.35-5.09-8.458-7.274-13.643-4.88-5.184 2.393-7.482 8.46-5.133 13.55 2.35 5.089 8.458 7.274 13.643 4.88Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32 50.49c3.53.91 7.18-1.19 8.14-4.7",
    stroke: "#fff",
    strokeWidth: 1.033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.402 45.896a.641.641 0 0 0 .327-.845.641.641 0 0 0-.855-.3.64.64 0 0 0-.326.845.64.64 0 0 0 .854.3ZM150.315 41.569c.326-.15.472-.529.326-.845a.641.641 0 0 0-.855-.3.642.642 0 0 0-.326.845c.146.316.529.45.855.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.09 109.69h51.99V58.18l-51.99 51.51Zm45.15-8.87H171.6l25.64-26.58v26.58Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78 78.34 186 76.56M181.27 84.84l-1.78-1.77M175.35 90.76l-1.77-1.77M168.84 97.27l-1.77-1.78",
    stroke: "#4263EB",
    strokeWidth: 1.033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.88 71.24-1.78-1.78",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 116.05a3.733 3.733 0 0 1 .05-5.29l34.43-33.84 5.24 5.33-34.43 33.84a3.724 3.724 0 0 1-5.29-.04Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.23 66.04 3.84 7.46 14.19 14.44 5.93-5.83-13.91-14.14-7.68-4.26-2.37 2.33Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.41 64.87 19.81 20.15M138.481 75.88c-.49.48-1.93-.19-3.22-1.5-1.29-1.31-1.93-2.76-1.44-3.24",
    stroke: "#4263EB",
    strokeWidth: 1.033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.66 73.03-8.74 11.19M154.33 71.21l4.66 3.64M129.2 106.35l-14.1 1.74M128.84 103.42l.72 5.87M145.63 93.83l-13.08 5.54M144.47 91.1l2.31 5.45",
    stroke: "#4263EB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.379 94.904-4.752-4.752-23.752 23.752 4.752 4.752L44.38 94.904Z",
    fill: "#4263EB",
    stroke: "#4263EB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.91 85.62-9.28 4.53 4.75 4.75 4.53-9.28Z",
    fill: "#4C6EF5",
    stroke: "#4C6EF5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.47 116.06 2.38 2.38c-1.3 1.3-3.45 1.3-4.75 0-1.3-1.3-1.3-3.45 0-4.75l.03-.03 2.34 2.4Z",
    fill: "#364FC7",
    stroke: "#364FC7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.75 86.91.87.87 1.29-2.16-2.16 1.29Z",
    fill: "#364FC7",
    stroke: "#364FC7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13 66.66c-3.69.92-3.69 4.61-11.06 4.61H66.65c-2.54 0-4.61-2.06-4.61-4.61H48.23l2.86 14.3a5.14 5.14 0 0 0 5.04 4.13h38.85c1.36 0 2.68-.4 3.81-1.15 5.95-3.97 11.17-9.9 11.17-19.12l-13.83 1.84Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.68 85.08H65.73v7.37h23.95v-7.37Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.05 66.66H42.7v-6.45h14.34c2.76 0 5 2.24 5 5v1.45h.01Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.17 62.97-23.04 3.69M80.47 71.26v-4.6M102.58 65.74v-6.45M103.5 48.23v-3.68M103.5 33.49v-9.21",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32 27.96h11.06l-5.45-2.05 5.45-2.55h-11.06v4.6ZM79.29 18.09h11.05l-7.27-2.83 7.27-1.78H79.29v4.61ZM58.1 24.28h11.05l-7.37-1.92 7.37-2.69H58.1v4.61Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.95 33.49s5.03 2.71 1.69 10.57h11.4s.51-6.88-3.43-10.57h-9.66ZM97.18 48.05s3.811 4.55 0 10.66h13.791s1.76-5.87-1.93-10.48l-11.86-.18ZM73.1 37.18h14.73s11.07 12.9 3.7 28.56H72s10.31-11.98 1.1-28.56ZM74.02 22.43H84.3s4.46 6.03 1.69 10.38H74.94c0 .01 4.61-4.85-.92-10.38ZM52.83 30.73h10.79s11.32 6.45 6.71 24.88H51.22c0-.01 7.14-10.14 1.61-24.88Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36 60.21v-3.69M59.28 29.8v-8.29M80.47 22.43v-5.52M80.47 37.18v-3.69",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 76.93h40.45M95.98 81.37H85.13",
    stroke: "#364FC7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9 41.38s5.21 6.03 3.65 13.03M107.65 50.54s1.35.42 1.4 3.87M104.891 35.78s1.04.08 1.44 3.98M83.03 24.49s1.83 1.45 1.53 4.4M63.97 33.49s4.28 3.24 3.41 7.89",
    stroke: "#4263EB",
    strokeWidth: 1.033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.93 1.338-7.915 4.57 4.57 7.915 7.915-4.57-4.57-7.915Z",
    stroke: "#4263EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92 6.5a3.02 3.02 0 1 0 0-6.04 3.02 3.02 0 0 0 0 6.04Z",
    stroke: "#4263EB",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.27.78-10.94 13.47",
    stroke: "#4263EB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLeftImage);
export default __webpack_public_path__ + "static/media/historyLeftImage.0660d32f1b7cdfab380c275394e2e1b9.svg";
export { ForwardRef as ReactComponent };